import { pickThemeColor } from '@/theme';
import { Drawer } from '@/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
`;

export const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-footer {
    background-color: ${pickThemeColor('BG_SECONDARY')};
    padding: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
